function Codex() {
  return (
    <>
      <div className="inner">
        <div className="links">
          <a href="https://github.com/kvh8899/week13-project">
            <i className="fa-brands fa-github"></i>
          </a>
        </div>
        <a href="https://codexappaa.herokuapp.com/">
          <img
            src="https://github.com/kvh8899/week13-project/raw/main/docs/images/screens-readme/homepage.png"
            alt="Codex"
            className="projectPreviewBlack"
          ></img>
        </a>
      </div>
      <a href="https://codexappaa.herokuapp.com/" style={{ color: "black" }}>
        <h3>Codex - Computer Science News and Articles</h3>
      </a>
    </>
  );
}

export default Codex;
